module.exports = __webpack_public_path__ + "static/img/s70.ae78193a.png";